import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StateViewer } from '../../../core/model/inventories';

@Component({
  selector: 'app-template-viewer',
  templateUrl: './template-viewer.component.html',
  styleUrls: ['./template-viewer.component.css']
})
export class TemplateViewerComponent implements OnInit {

  @Input() cssClassValues: string;
  @Input() cssClassShoppingCart: string;
  @Input() isInventoryView: boolean;
  @Input() hasPrestamoActivo = false;
  @Input() hasInsercionActiva = false;
  @Input() fullTextSummary;
  @Input() fieldsToShow: { key: string; value: any; }[] = [];
  @Input() shoppingCart;
  @Input() hasActiveState = false;

  @Input() estadosViewer: StateViewer[];
  @Input() nombreSerie: string;
  @Input() imageMiniaturaSrc: ArrayBuffer;
  @Input() imageDefaultPath: string;

  @Output() editObsPartialEvent = new EventEmitter<boolean>();
  @Output() removeElement = new EventEmitter<boolean>();
  @Output() createLoanEvent = new EventEmitter<boolean>();
  @Output() createInsertionEvent = new EventEmitter<boolean>();
  @Output() openObsPartialModalEvent = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

}
